module.exports = __webpack_public_path__ + "static/img/qie1.0b1986e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qie1.png
// module id = 3odk
// module chunks = 1